import * as moment from 'moment'
import * as React from 'react'
import DatePicker from 'react-datepicker'
import { FieldModel } from 'typings/api-models/creditCheck'
import Label from '../_atoms/label'

export default class TextInput extends React.Component<TextInputProps> {
 
  constructor(props: TextInputProps) {
    super(props)
    this.handleChangeWrapper = this.handleChangeWrapper.bind(this)
  }

  public handleChangeWrapper(e: moment.Moment): void {
    const fakeEvent = {
      currentTarget: {
        value: e.format('MM/DD/YYYY')
      }
    }

    this.props.handleChange(this.props.field, fakeEvent, false)
  }

  public render(): JSX.Element {
    const { field } = this.props
    return (
      <div className={this.props.className + ' form-group formGroup birthday-wrapper'}>
        <Label className="control-label">
          {field.label}
          {field.required ? '*' : ''}
          <span className="warning-icon icon" />
        </Label>
        <div>
          <DatePicker
            id={'datePickerWrap'}
            className="col-12"
            dateFormat="MM/DD/YYYY"
            onChange={this.handleChangeWrapper}
            showMonthDropdown={true}
            showYearDropdown={true}
            dropdownMode="select"
            minDate={moment('1/1/1900')}
            maxDate={moment().subtract(18, 'years')}
            selected={field.value.length > 0 && moment(field.value).isValid ? moment(field.value) : null}
            readOnly={true}
          />
        </div>
      </div>
    )
  }
}

/* tslint:disable no-any */
interface TextInputProps extends React.AllHTMLAttributes<HTMLDivElement> {
  field: FieldModel<string>
  handleChange: any
  className: string
}
/* tslint:enable no-any */



// WEBPACK FOOTER //
// ./src/components/_molecules/DatePickerWrapper.tsx